<div class="app-study-read-only-section">
  <ng-content></ng-content>
</div>
